export { default as Tancadas } from "./Tancadas";

